function DiceIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g transform="translate(0, 0) rotate(-20, 10, 12)">
        <rect x="2" y="2" width="14" height="14" rx="2" fill="#fce7f3"/>
        <circle cx="7" cy="7" r="1.2" fill="#FFFFFF"/>
        <circle cx="10" cy="10" r="1.2" fill="#FFFFFF"/>
        <circle cx="13" cy="13" r="1.2" fill="#FFFFFF"/>
      </g>
      <g transform="translate(7, 6) rotate(15, 10, 10)">
        <rect x="2" y="2" width="14" height="14" rx="2" fill="#bfdbfe"/>
        <circle cx="6" cy="6" r="1.2" fill="#FFFFFF"/>
        <circle cx="12" cy="6" r="1.2" fill="#FFFFFF"/>
        <circle cx="9" cy="9" r="1.2" fill="#FFFFFF"/>
        <circle cx="6" cy="12" r="1.2" fill="#FFFFFF"/>
        <circle cx="12" cy="12" r="1.2" fill="#FFFFFF"/>
      </g>
    </svg>
  );
}

export default DiceIcon;
